/**
 * Gets the current page URL as a referrer.
 *
 * Handles localhost special case by constructing URL manually.
 *
 * @returns The current page URL string
 */
export default function getReferrer(): string {
  // to make it work on localhost, construct url manually
  if (document.location.hostname === 'localhost') {
    return `${window.host}${document.location.pathname}${document.location.search}`
  }
  return document.location.href
}
